export const ROOT_NODE = 'EVENTS_ROOT_NODE';
export const MODALS_ROOT_NODE = 'EVENTS_MODALS_ROOT_NODE';
export const RIBBON = 'ribbon';
//# sourceMappingURL=viewer.js.map